import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import compare from 'just-compare';
import { ReplaySubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as fromShared from '../../shared';
import { ResponseStatus, SelectItem } from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { ServiceItem } from '../store/service-item.model';

@Component({
    selector: 'ef-service-item',
    templateUrl: './service-item.component.html',
    styleUrls: ['./service-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ServiceItemComponent
    extends fromShared.Errors.DisplayErrors<ServiceItem>
    implements OnInit, OnChanges
{
    @Input() serviceItemsSelectItems: SelectItem[] = [];
    dropdownItemHeight = environment.dropdownItemHeight;
    @Output() public Save = new ReplaySubject<Partial<ServiceItem>>(1);
    @Output() public SelectItem = new ReplaySubject<ServiceItem[]>(1);
    selected: ServiceItem[] = [];
    private editing: ServiceItem;
    constructor(private log: LoggingService) {
        super();
    }
    ngOnInit() {}
    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        this.log.verbose({
            type: 'ServiceItemComponent:ngOnChanges',
            changes
        });
        if (changes.items) {
            this.selected =
                changes.items.currentValue && changes.items.currentValue.length
                    ? [changes.items.currentValue[0]]
                    : [];
            this.SelectItem.next(this.selected);
        }
    }
    onEditComplete($event: { data: ServiceItem }) {
        this.log.verbose({
            type: 'ServiceItemComponent:onEditComplete',
            $event
        });
        if (!compare($event.data, this.editing)) {
            const item = this.items.find(
                x => x.SIListID === $event.data.SIListID
            );
            if (!!item) {
                item.Status.StatusCode = ResponseStatus.Loading;
                item.Status.Message = 'Saving';
                this.onSave($event.data);
            }
        }
    }
    protected onSave(item: ServiceItem) {
        const _pi: ServiceItem = {
            ...item,
            Status: {
                StatusCode: ResponseStatus.Loading,
                Message: ''
            }
        };
        this.log.verbose({
            type: 'ServiceItemComponent:onSave',
            pi: item,
            _pi
        });

        this.Save.next(_pi);
    }
}
